import styled from 'styled-components';

export const DivContainer = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: row;
  background-color: #FFFFFF;
  justify-content: center;
`;

export const DivHeaderActions = styled.div`
  display: flex;
  flex:1 auto;
  flex-direction: row;
  justify-content: flex-end;
  background-color: #173f4f;
`;
export const DivTitle = styled.div`
  font-size: 1em;
  padding-bottom: 10px;
  font-weight: bold;
`

export const DivContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap : wrap;
`;


// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/styled.js